module.exports = __webpack_public_path__ + "static/media/interiordesigning.200db89e.jpg";